import React, { useEffect, useState } from "react";
import "./styles.scss";
import img from "../../assets/images/Vector.svg";
import TotalCard from "../../assets/images/totalCard.svg";
import del from "../../assets/images/Test.svg";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Snackbar } from "@material-ui/core";
import { Alert } from "react-bootstrap";
import { Card, Modal } from "react-bootstrap";
import { Popup } from "../../components";
import { testValue } from "../../redux/auth/actions";
import axios from "axios";


function CardSelectedTest(props) {
  const history = useHistory();
  const dispatch = useDispatch();

  const [showPopup, setShowPopup] = useState(false);

  const handleButtonClick = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const cities = useSelector((state) => state.auth.cities);
  let uuidpartner = props.recPartnerUuid;
  console.log(uuidpartner, props , "propspropsprops")

  const selected_test = useSelector(
    (state) => state.selected_test.selected_test
  );

  const cityState = useSelector((state) =>
    state.city !== undefined && state.city.label !== undefined ? state.city : ""
  );
  const areaState = useSelector((state) =>
    state.area !== undefined && state.area.area !== undefined
      ? state.area.area
      : ""
  );
  const [open, setOpen] = React.useState(true);

  const [data, setData] = React.useState({
    data: [],
    homeservice: "yes",
    recommended_test: {},
  });
  const [locationPOP, showLocationPop] = React.useState(false);
  const [addedItems, setAddedItems] = React.useState([]);

  React.useEffect(() => {
    if (selected_test && selected_test.length !== 0) {
      let res = [];
      let recommended_test_uuid = [];
      let patientName = "";
      let patientId = "";

      selected_test.map((v, i) => {
        if (v.patient_uuid) {
          recommended_test_uuid.push(v.doc.testname_uuid);
          patientName = v.patient_name;
          patientId = v.patient_uuid;
        }
        v && v.doc && v.doc.testname_uuid && v.doc.testname_uuid !== undefined
          ? res.push({
              test_type:
                v.doc.testname_uuid.slice(0, 2) === "LP"
                  ? "pathology"
                  : v.doc.testname_uuid.slice(0, 2) === "LR"
                  ? "radiology"
                  : v.doc.testname_uuid === undefined
                  ? "biochecks"
                  : "nodata",
              testname_uuid: v.doc.testname_uuid,
              testName : v.doc.standardisedtestname,
              areaRef: areaState.value,
              // recommended_test: { patient_name: v.patient_name, patient_uuid: v.patient_uuid }
            })
          : res.push({
              test_type: "biochecks",
              uuid: v && v.doc && v.doc.uuid && v.doc.uuid,
            });
      });
      let dataToSend = {
        data: res,
        homeservice: "yes",
        recommended_test: {
          test_uuid: recommended_test_uuid,
          patient_name: patientName,
          patient_uuid: patientId,
        },
        uuidpartner: { uuidpartner },
      };
      setData(dataToSend);
    }
  }, [selected_test]);

  const handleValidation = () => {
    if (selected_test && selected_test.length !== 0 && areaState.value !== "") {
      return true;
    } else {
      return false;
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handlePopupClose = () => {
    showLocationPop(false);
  };

  const handleItems = (id, val) => {
    const idToRemove = id;
    if (addedItems.includes(val)) {
      const filteredPeople = addedItems.filter(
        (item) => item.id !== idToRemove
      );
      setAddedItems(filteredPeople);
    } else {
      setAddedItems([...addedItems, val]);
    }
    dispatch(testValue(val));
  };

  const arealocal = useSelector((state) => state.area);

  return (
    <>
      <div className="CardSelectedTest">
        <div className="header">Selected Tests</div>
        {selected_test && selected_test.length === 0 ? (
          <>
            <img className="SelectedTestImg" src={TotalCard} alt="icon" />
            <div className="Card_txt">You don’t have any test selected yet</div>
          </>
        ) : (
          selected_test &&
          selected_test.map((val, i) => (
            <div className="selectedCard" key={i}>
              {val && val.standardisedtestname !== undefined
                ? val.standardisedtestname
                : val && val.doc && val.doc.standardisedtestname !== undefined
                ? val.doc.standardisedtestname
                : val.doc && val.doc.paneltestname && val.doc.paneltestname}
              {val && val.standardisedtestname !== undefined ? (
                <img
                  src={del}
                  alt="icon"
                  style={{ cursor: "pointer" }}
                  onClick={() => props.del(val)}
                />
              ) : val &&
                val.doc &&
                val.doc.standardisedtestname !== undefined ? (
                <img
                  src={del}
                  alt="icon"
                  style={{ cursor: "pointer" }}
                  onClick={() => props.del(val)}
                />
              ) : (
                <img
                  src={del}
                  alt="icon"
                  style={{ cursor: "pointer" }}
                  onClick={() => props.del(val)}
                />
              )}
            </div>
          ))
        )}
        {handleValidation() ? (
          <div
            className="ComparePrices"
            onClick={() =>
              arealocal &&
              arealocal.area &&
              arealocal.area.value &&
              arealocal.area.value === ""
                ? showLocationPop(true)
                : history.push({ pathname: "/compareprice", state: data })
            }
          >
            Compare Prices
          </div>
        ) : (
          <div
            className="ComparePrices"
            style={{ cursor: "not-allowed", opacity: "0.5" }}
            // style={{ cursor: "not-allowed", opacity: "0.5" }}
            // onClick={() => {
            //   props.handleLocPop && props.handleLocPop();
            // }}
            aria-disabled
          >
            Compare Prices
          </div>
        )}
      </div>
      {/* <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert severity="error">
          {selected_test.length === 0
            ? "please select the test!"
            : "please select the location!"}
        </Alert>
      </Snackbar> */}

<button className="fixedButton" onClick={handleButtonClick}>

<svg xmlns="http://www.w3.org/2000/svg" height="2em" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16" id="IconChangeColor"> <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" id="mainIconPathAttribute" fill="#ffffff"></path> </svg>
</button>

{/* Popup */}
{showPopup && (
  <div className="popup">
    <p>We're here to assist you! If you have any difficulties finding tests, locating a lab, or have any questions, feel free to reach out to us on WhatsApp at <span style={{cursor:"grab",fontWeight:"bold",color:"#ff5c3c"}}>+2349010996000</span>. Our team is ready to help you find the right diagnostic solutions and ensure a smooth experience.</p>
    <button className="popupButton" onClick={closePopup}>Close</button>
  </div>
)}



      <Modal
        backdrop="static"
        keyboard={false}
        show={locationPOP}
        onHide={handlePopupClose}
      >
        <Popup city={cities} type="landingPage" addedItems={addedItems} />
      </Modal>
    </>
  );
}

export default CardSelectedTest;
